import { Form } from "semantic-ui-react";
import { PermitFieldValueInput } from "../../models/globalTypes";
import { NumberTemplateField } from "../../models/TemplateField";

interface Props {
  field: NumberTemplateField;
  value: PermitFieldValueInput | undefined;
  onChange: (fieldKey: string, update: Partial<PermitFieldValueInput>) => void;
  disabled: boolean;
  error: string | undefined;
  required?: boolean;
}

const NumberFieldInput = ({ field, value, onChange, disabled, error, required }: Props) => {
  const currentValue = value?.numberValue ?? "";
  const step = field.decimalPlaces != null ? Math.pow(10, -field.decimalPlaces) : undefined;

  return (
    <Form.Field required={required}>
      <label>{`${field.label}${field.unit ? ` (${field.unit})` : ""}`}</label>
      <Form.Input
        type="number"
        value={currentValue}
        min={field.minValue ?? undefined}
        max={field.maxValue ?? undefined}
        step={step}
        disabled={disabled}
        error={error}
        onChange={(_, { value: v }) => onChange(field.key, { numberValue: v ? parseFloat(v as string) : null })}
      />
    </Form.Field>
  );
};

export default NumberFieldInput;
